/* eslint-disable @typescript-eslint/naming-convention */
export enum DataLayerEvent {
  CUSTOMER_ACCOUNTS = 'customer_accounts',
  CUSTOMER_CITY = 'customer_city',
  VIEW_ITEM_LIST = 'view_item_list',
  VIEW_ITEM = 'view_item',
  ADD_TO_CART = 'add_to_cart',
  PURCHASE = 'purchase',
  ECOM_ERROR = 'ecom_error',
}

export enum DataLayerEcomErrors {
  UNPAID_BILL_ERROR = 'unpaid bill',
  ALREADY_BOUGHT_ERROR = 'already bought',
  RESTRICTED_PURCHASE_ERROR = 'restricted purchase',
  GENERIC_ERROR = 'generic error',
  NO_SERVICE_LOCATION_ERROR = 'no service location',
  INFLIGHT_ORDER_ERROR = 'inflight order',
  OUT_OF_STOCK_ERROR = 'out of stock',
  NOT_AVAILABLE_PARTNER_ERROR = 'no available partner',
  SESSION_EXPIRED_ERROR = 'session expired',
  WRONG_ROLE = 'wrong user role',
}

interface CommonDataLayerProperties {
  event: DataLayerEvent;
  logged_in: boolean;
  partner_id: string;
  customer_id: string;
  user_id: string;
}

export interface CustomerAccountDataLayer extends CommonDataLayerProperties {
  account_count: number;
}

export interface CustomerCityDataLayer extends CommonDataLayerProperties {
  zip_code: string;
}

export interface EcomErrorDataLayer extends Omit<CommonDataLayerProperties, 'partner_id'> {
  partner_id?: string;
  error_message: string;
  error_product: string;
}

export interface ProductInformationDataLayer {
  event: DataLayerEvent;
  ecommerce: Ecommerce;
}

export interface PurchaseInformationDataLayer {
  event: DataLayerEvent;
  ecommerce: Purchase;
}

export interface DataLayerProduct {
  item_id: string;
  item_name: string;
  coupon?: string;
  currency: string;
  discount?: string;
  index: number;
  item_brand: string;
  item_category: string;
  item_category2: string;
  item_category3?: string;
  item_category4?: string;
  item_category5?: string;
  item_list_id?: string[];
  item_list_name?: string[];
  price: number;
  quantity: number;
}

interface Ecommerce {
  items: DataLayerProduct[];
}

interface Purchase extends Ecommerce {
  transaction_id: string;
  value: number;
  currency: string;
}

export type DataLayerEventObject =
  | CustomerAccountDataLayer
  | CustomerCityDataLayer
  | ProductInformationDataLayer
  | PurchaseInformationDataLayer
  | EcomErrorDataLayer;
